import { AxArtwork } from "@dynata/axiom3";
import errorImage from "@dynata/axiom3-images/png/general_error.png";

export function AudiencesError() {
  return (
    <AxArtwork
      title="There was an error loading audiences"
      image={errorImage}
      description="Error details"
    />
  );
}
